import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
  selector: '[app-content-host]',
})
export class AppContentDirective {
  constructor(public viewContainerRef: ViewContainerRef) { }
}
